class SectionWithBorder {
  constructor($element) {
    this.$element = $element;

    this.setVars();
    this.bindUI();
    this.bindEventHandlers();
    this.bindObservers();
  }

  bindEventHandlers() {
    // Defining this as an anonymous function prevents it from being removed
    this.handleScroll = this.handleScroll.bind(this);
  }

  /**
   * Determine when to add a more fine-grained scroll event listener, and when
   * to remove it.
   */
  bindObservers() {
    const options = {
      rootMargin: '80px',
    };
    const observer = new IntersectionObserver( (entries) => {
      if (entries[0]?.isIntersecting) {
        this.hasIntersected = true;

        document.addEventListener('scroll', this.handleScroll);
        this.handleScroll();
      } else if (this.hasIntersected) {
        // Only reset site nav if this element has previously intersected the
        // viewport. This prevents overriding a hidden border initiated by
        // a different element.
        document.removeEventListener('scroll', this.handleScroll);

        // Reset all properties used to hide site nav border
        this.elementRect = null;
        this.hideBorder = false;
        this.showStickyTop = false;

        this.render();
      }
    }, options);

    observer.observe(this.$element);
  }

  bindUI() {
    this.$siteNav = document.querySelector('[data-ref="SiteHeader"]');
    this.$navMarginState = document.querySelector('[data-ref="$navMarginState"]');
  }

  /**
   * Gradually decrease the debounce timeout as the top of the element
   * approaches the top of the viewport for improved scroll performance.
   * @return {Number}
   */
  getDebounceTimeout() {
    if (!this.elementRect) {
      return 1000;
    } else if (this.elementRect.top > 1000) {
      return 500;
    } else if (this.elementRect?.top > 500) {
      return 250;
    } else {
      return 50;
    }
  }

  /**
   * Calculate whether the element is intersecting with the site nav, setting
   * properties as appropriate that will be used by render() to show or hide
   * the border.
   */
  handleScroll() {
    if (!this.debounce) {
      const {bottom, top} = this.$element.getBoundingClientRect();
      this.elementRect = {top, bottom};
      this.debounce = setTimeout(() => delete this.debounce, this.getDebounceTimeout());

      const topIsIntersecting = top < this.NAV_HEIGHT - this.BORDER_WIDTH;
      const bottomIsIntersecting = bottom < this.NAV_HEIGHT;

      // If the top has scrolled under the site nav, hide the border. When the
      // bottom has also scrolled under site nav, show the border again.
      this.hideBorder = topIsIntersecting && !bottomIsIntersecting;

      // Tell the element it should make its sticky top visible when its top
      // meets the site nav's top border boundary.
      this.showStickyTop = this.elementRect.top < this.BORDER_WIDTH && !bottomIsIntersecting;

      this.render();
    }
  }

  render() {
    this.$siteNav.dataset.hideBorder = this.hideBorder || false;
    this.$element.dataset.showStickyTop = this.showStickyTop || false;
  }

  setVars() {
    this.BORDER_WIDTH = 8;
    this.NAV_HEIGHT = 64 + 2 * this.BORDER_WIDTH;

    this.hasIntersected = false; // whether or not the element has ever intersected the viewport
  }
}

document.querySelectorAll('[data-reveal-border="true"]').forEach(($element) => {
  new SectionWithBorder($element);
});
